import React, { useEffect, useState, useContext } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { CButton, CCard, CCol, CFormCheck, CFormInput, CFormSelect, CRow } from '@coreui/react'
import './content.scss'
import {
  getArtistAction,
  getParentContentAction,
  getVenuesAction,
} from '../../../Redux/Actions/assetAction'
import { isEmpty, masterAndChildIntersection } from '../../utils/helper'
import { getCategoriesAction } from '../../../Redux/Actions/metaDataAction'
import { getThumbnail } from '../../utils/helper'
import { GlobalContext } from 'src/views/context/GlobalState'
import { CustomDescriptionBox } from '../../../components'
import ImageUploader from 'src/components/ImageUploader/ImageUploader'
import CustomMultiSelect from 'src/components/customMultiSelect/customMultiSelect'

const ContentDetails = (props) => {
  const { toggleValue, isEdit, details, cancelModal } = props
  const dispatch = useDispatch()
  const { userSessionObj } = useContext(GlobalContext)

  const [thumbnail, setThumbnail] = useState({
    website: '',
    mobile: '',
  })

  const [thumbnailData, setThumbnailData] = useState([
    {
      title: '',
      id: 'thumbnailWeb',
      uploadIconflexRow: true,
      width: 640,
      height: 360,
      divheight: '7.72vw',
      divwidth: '13.68vw',
      assetId: '',
      setAssetId: (id) => {
        handleClearError('thumbnail')
        setThumbnail({
          website: id,
          mobile: id,
        })
      },
      setImage: () => {},
      onRemoveImg: () => {},
      imageUrl: '',
    },
  ])
  const [bannerData, setBannerData] = useState([
    {
      title: '',
      id: 'bannerWeb',
      uploadIconflexRow: true,
      width: 1200,
      height: 675,
      divheight: '7.72vw',
      divwidth: '13.68vw',
      assetId: '',
      setAssetId: (id) => {
        handleClearError('poster')
        setPoster({
          website: id,
          mobile: id,
        })
      },
      setImage: () => {},
      onRemoveImg: () => {},
      imageUrl: '',
    },
  ])

  const [poster, setPoster] = useState({
    website: '',
    mobile: '',
  })

  const [title, setTitle] = useState('')
  const [description, setDescription] = useState('')
  const [artist, setArtist] = useState([])
  const [venues, setVenues] = useState([])
  const [liveComments, setLiveComments] = useState(false)

  const [categories, setCategories] = useState([])
  // const [category, setCategory] = useState([])
  const [categoriesMaster, setCategoriesMaster] = useState([])
  const [subCategories, setSubCategories] = useState([])

  const [artistMaster, setArtistMaster] = useState([])
  const [venueMaster, setVenueMaster] = useState([])
  const [parentContentMaster, setParentContentMaster] = useState([])
  // const [releaseDate, setReleaseDate] = useState('')

  const [errorData, setErrorData] = useState({})
  const [descriptionError, setDescriptionError] = useState('')

  const [parentContent, setParentContent] = useState('')
  const [episodeNo, setEpisodeNo] = useState(0)

  const content = useSelector((state) => state.contentReducer)

  useEffect(() => {
    if (isEdit && !isEmpty(details)) {
      setTitle(details['title'])
      if (details?.description) {
        setDescription(details['description'])
      }

      setArtist(masterAndChildIntersection(artistMaster, details?.artists))
      setVenues(masterAndChildIntersection(venueMaster, details?.venues))
      setLiveComments(details?.live_comments_applicable ? true : false)
      let isCategoryActive = !isEmpty(
        masterAndChildIntersection(categoriesMaster, details?.category),
      )
      setCategories(
        isCategoryActive ? masterAndChildIntersection(categoriesMaster, details?.category) : [],
      )
      if (details?.sub_categories) {
        setSubCategories(
          isCategoryActive
            ? masterAndChildIntersection(categoriesMaster, details?.sub_categories)
            : [],
        )
      }

      setThumbnail({
        mobile: details?.thumbnail?.mobile?._id ? details?.thumbnail?.mobile?._id : '',
        website: details?.thumbnail?.website?._id ? details?.thumbnail?.website?._id : '',
      })

      setThumbnailData([
        {
          title: '',
          id: 'thumbnailWeb',
          uploadIconflexRow: true,
          width: 640,
          height: 360,
          divheight: '7.72vw',
          divwidth: '13.68vw',
          assetId: details['thumbnail']['website']['_id'],
          setAssetId: (id) => {
            handleClearError('thumbnail')
            setThumbnail({
              website: id,
              mobile: id,
            })
          },
          setImage: () => {},
          onRemoveImg: () => {},
          imageUrl: getThumbnail(
            userSessionObj.session_data.cf_domain_name,
            details?.thumbnail?.website?.s3_key,
          ),
        },
      ])

      setPoster({
        mobile: details?.poster?.mobile?._id ? details?.poster?.mobile?._id : '',
        website: details?.poster?.website?._id ? details?.poster?.website?._id : '',
      })

      setBannerData([
        {
          title: '',
          id: 'bannerWeb',
          uploadIconflexRow: true,
          width: 1200,
          height: 675,
          divheight: '7.72vw',
          divwidth: '13.68vw',
          assetId: details['poster']['website']['_id'],
          setAssetId: (id) => {
            handleClearError('poster')
            setPoster({
              website: id,
              mobile: id,
            })
          },
          setImage: () => {},
          onRemoveImg: () => {},
          imageUrl: getThumbnail(
            userSessionObj.session_data.cf_domain_name,
            details?.poster?.website?.s3_key,
          ),
        },
      ])

      if (details?.video_type === 'MPVC' && details?.parent) {
        setParentContent(details['parent'])
        setEpisodeNo(details['serial_no'])
      }
    }
  }, [isEdit, details, categoriesMaster, artistMaster, venueMaster])

  useEffect(() => {
    getCategories()
    getArtist()
    getVenues()
    getParentContent()
  }, [])

  useEffect(() => {
    if (content?.video_type === 'PLAYLIST' && !isEmpty(content?.category)) {
      let catArr = []
      let subCatArr = []
      let artistArr = []
      let venueArr = []
      for (let i = 0; i < content?.category.length; i++) {
        const element = content?.category[i]
        let obj = categoriesMaster.find((catObj) => catObj._id === element.id)
        if (obj) catArr.push(obj)
      }

      for (let i = 0; i < content?.sub_categories.length; i++) {
        const element = content?.sub_categories[i]
        let obj = categoriesMaster
          .filter((cat) => cat.type === 'sub_category')
          .find((catObj) => catObj._id === element.id)
        if (obj) subCatArr.push(obj)
      }

      for (let i = 0; i < content?.artists.length; i++) {
        const element = content?.artists[i]
        let obj = artistMaster.find((artObj) => artObj._id === element.id)
        if (obj) artistArr.push(obj)
      }
      for (let i = 0; i < content?.venues.length; i++) {
        const element = content?.venues[i]
        let obj = venueMaster.find((venObj) => venObj._id === element.id)
        if (obj) venueArr.push(obj)
      }

      setCategories([...catArr])
      setSubCategories([...subCatArr])
      setArtist([...artistArr])
      setVenues([...venueArr])
    }
  }, [content?.category])

  const getCategories = async () => {
    const res = await dispatch(getCategoriesAction())
    if (res?.success) {
      setCategoriesMaster(res.data.filter((item) => item.status))
      console.log(res.data.filter((item) => item.status))
    }
  }

  const getArtist = async () => {
    const artistData = await dispatch(getArtistAction())

    if (!isEmpty(artistData)) {
      setArtistMaster(
        artistData.data
          .filter((item) => item.status)
          .map((item) => ({ ...item, display: item.name + ' (' + item.artist_type + ')' })),
      )
    }
  }

  const getVenues = async () => {
    const venueData = await dispatch(getVenuesAction())

    if (!isEmpty(venueData)) {
      setVenueMaster(venueData.data.filter((item) => item.status))
    }
  }

  const getParentContent = async () => {
    const parentContentData = await dispatch(getParentContentAction())

    if (!isEmpty(parentContentData)) {
      setParentContentMaster(parentContentData.data)
    }
  }

  const handleClearError = (field) => {
    if (errorData && errorData[field]) {
      // errorData[field] = ''
      setErrorData({ ...errorData, [field]: '' })
    }
  }

  const validateInfo = () => {
    let isFormValid = true
    let temp = {
      title: '',
      description: '',
      // category: '',
      artist: '',
      thumbnail: '',
      poster: '',
      parentContent: '',
      episode_no: '',
    }

    if (title.trim().length === 0) {
      isFormValid = false
      temp.title = 'Title cannot be empty!'
    }
    // if (description.trim().length === 0) {
    //   isFormValid = false
    //   setDescriptionError('Description cannot be empty!')
    // }
    if (categories.length === 0) {
      isFormValid = false
      temp.category = 'Select Category!'
    }
    // if (geoBlocking && geoBlockCountries.length === 0) {
    //   isFormValid = false
    //   temp.geoBlockCountries = 'Select Countries!'
    // }

    if (!thumbnail.website) {
      isFormValid = false
      temp.thumbnail = 'Upload content thumbnail!'
    }
    if (!poster.website) {
      isFormValid = false
      temp.poster = 'Upload content banner!'
    }

    if (content.video_type === 'MPVC') {
      if (isEmpty(parentContent)) {
        isFormValid = false
        temp.parentContent = 'Please attach a parent content!'
      }

      if (episodeNo === 0) {
        isFormValid = false
        temp.episode_no = 'Please provide episode number!'
      }
    }

    setErrorData({ ...temp })
    return isFormValid
  }

  const handleSave = () => {
    if (validateInfo()) {
      dispatch({
        type: 'CONTENT_DETAILS',
        payload: {
          title: title,
          description: description,
          category: categories,
          subCategories: subCategories,
          artists: artist,
          venues: venues,
          liveComments: content.video_type === 'LIVE' ? liveComments : false,
          thumbnail: thumbnail,
          poster: poster,
          parentContent: parentContent,
          episodeNo: episodeNo,
        },
      })
      toggleValue(4)
    }
  }

  const handleCategory = (value) => {
    let selectedCat = value.map((info) => info._id)
    let newSub = subCategories.filter((subCat) =>
      subCat.categories.some((parentCatoryId) => selectedCat.indexOf(parentCatoryId) >= 0),
    )
    setSubCategories(newSub)
    setCategories(value)
  }

  const getSubCategory = () => {
    let selectedCat = categories.map((info) => info._id)
    let subCategoryMaster = categoriesMaster.filter((cat) => cat.type === 'sub_category')

    return subCategoryMaster.filter((subCat) =>
      subCat.categories.some((parentCatoryId) => selectedCat.indexOf(parentCatoryId) >= 0),
    )
  }

  const handleParentContent = (value) => {
    setParentContent(value)
  }
  return (
    <>
      <CCard style={{ padding: '0 4.7vw' }}>
        <div style={{ marginTop: '2.5vw' }}>
          <h4 style={{ fontSize: '1.5vw', fontWeight: '700' }}>
            GENERAL INFORMATION ABOUT THE CONTENT
          </h4>
          <div className="d-flex justify-content-between" style={{ gap: '1vw' }}>
            <div
              className="rounded-1"
              style={{
                padding: '.8vw 4%',
                width: 'calc(calc(53% + 3rem) + 1.68vw)',
                // height: '31vw',
                // aspectRatio: '753/582',
                backgroundColor: '#eeeeee',
                border: 'solid 0.5px #707070',
                boxShadow: '3px 3px 6px 0 rgba(0, 0, 0, 0.31)',
              }}
            >
              <div className="">
                <h6 style={{ fontSize: '.8vw', marginBottom: '.2vw' }} className="">
                  Title<span className="asterisk">*</span>
                </h6>
                <CustomDescriptionBox
                  limit={50}
                  rows={1}
                  placeholder="Title of the Content"
                  value={title}
                  onChange={(value) => {
                    setTitle(value)
                    handleClearError('title')
                  }}
                  isMandatory={true}
                  errorText={errorData.title}
                  style={{ fontSize: '12px', borderRadius: '2px' }}
                  limitFontSize={'11px'}
                />
                {/* <div className="message-text error-message">
                  <p>{errorData.title}</p>
                </div> */}
              </div>
              {content.video_type === 'MPVC' && (
                <CRow className="mt-3">
                  <CCol lg="8">
                    <h6 style={{ fontSize: '.8vw', marginBottom: '.2vw' }} className="">
                      Parent Content<span className="asterisk">*</span>
                    </h6>

                    <CFormSelect
                      value={parentContent}
                      onChange={(e) => {
                        handleClearError('parentContent')
                        handleParentContent(e.target.value)
                      }}
                      size="sm"
                    >
                      <option value="" disabled>
                        Select Parent Content
                      </option>
                      {!isEmpty(parentContentMaster) &&
                        parentContentMaster.map((content) => (
                          <option value={content._id} key={content._id}>
                            {content.title}
                          </option>
                        ))}
                    </CFormSelect>
                    <div className="message-text error-message">
                      <p>{errorData.parentContent}</p>
                    </div>
                  </CCol>
                  <CCol lg="4">
                    <h6 style={{ fontSize: '.8vw', marginBottom: '.2vw' }} className="">
                      Episode #<span className="asterisk">*</span>
                    </h6>

                    <CFormInput
                      type="number"
                      min="0"
                      placeholder="Provide episode no"
                      value={episodeNo}
                      onChange={(e) => {
                        setEpisodeNo(parseInt(e.target.value))
                        handleClearError('episode_no')
                      }}
                      size="sm"
                    />
                    <div className="message-text error-message">
                      <p>{errorData.episode_no}</p>
                    </div>
                  </CCol>
                </CRow>
              )}
              <div style={{ marginTop: '.95vw' }}>
                <h6 style={{ fontSize: '.8vw', marginBottom: '.2vw' }} className="">
                  Description
                </h6>
                <CustomDescriptionBox
                  limit={500}
                  rows={3}
                  placeholder="Description of the Content within 500 Characters"
                  value={description}
                  onChange={setDescription}
                  isMandatory={true}
                  errorText={descriptionError}
                  clearError={() => setDescriptionError('')}
                  style={{ fontSize: '12px', borderRadius: '2px', height: '' }}
                  limitFontSize={'11px'}
                />
              </div>
              {content.video_type === 'LIVE' && (
                <div>
                  <CFormCheck
                    label="Allow LIVE Comments"
                    checked={liveComments}
                    onChange={(e) => setLiveComments(e.target.checked)}
                    className="live-comments black-tick-checkbox"
                  />
                </div>
              )}
              <div style={{ marginTop: '.95vw' }}>
                <h6 style={{ fontSize: '.8vw', marginBottom: '.2vw' }} className="">
                  Category<span className="asterisk">*</span>
                </h6>
                <div>
                  <CustomMultiSelect
                    selectedValue={categories}
                    optionsData={categoriesMaster.filter((cat) => cat.type === 'category')}
                    onChange={handleCategory}
                    labelKey="name"
                    disabled={content?.video_type === 'PLAYLIST'}
                  />
                  <div className="message-text error-message">
                    <p>{errorData.category}</p>
                  </div>
                </div>
              </div>
              <div style={{ marginTop: '.95vw' }}>
                <h6 style={{ fontSize: '.8vw', marginBottom: '.2vw' }} className="">
                  Sub-Category
                </h6>
                <div>
                  <CustomMultiSelect
                    selectedValue={subCategories}
                    optionsData={getSubCategory()}
                    onChange={setSubCategories}
                    labelKey="name"
                    disabled={content?.video_type === 'PLAYLIST'}
                  />
                </div>
              </div>

              <div style={{ marginTop: '.95vw' }}>
                <h6 style={{ fontSize: '.8vw', marginBottom: '.2vw' }} className="">
                  Artist{' '}
                  <span style={{ fontWeight: '400', fontSize: '.6vw', marginLeft: '.75rem' }}>
                    (Optional)
                  </span>
                </h6>
                <div>
                  <CustomMultiSelect
                    selectedValue={artist}
                    optionsData={artistMaster}
                    onChange={setArtist}
                    labelKey="name"
                    disabled={content?.video_type === 'PLAYLIST'}
                  />
                </div>
              </div>

              <div style={{ marginTop: '.95vw' }}>
                <h6 style={{ fontSize: '.8vw', marginBottom: '.2vw' }} className="">
                  Venue{' '}
                  <span style={{ fontWeight: '400', fontSize: '.6vw', marginLeft: '.75rem' }}>
                    (Optional)
                  </span>
                </h6>
                <div>
                  <CustomMultiSelect
                    selectedValue={venues}
                    optionsData={venueMaster}
                    onChange={setVenues}
                    labelKey="name"
                    disabled={content?.video_type === 'PLAYLIST'}
                  />
                </div>
              </div>
            </div>
            <div
              className="d-flex flex-column align-items-center justify-content-evenly rounded-1"
              style={{
                width: 'calc(calc(31% + 3rem) + 1.68vw)',
                // height: '31vw',
                backgroundColor: '#eeeeee',
                border: 'solid 0.5px #707070',
                boxShadow: '3px 3px 6px 0 rgba(0, 0, 0, 0.31)',
              }}
            >
              <div className="d-flex flex-column align-items-center">
                <h6 style={{ fontWeight: '600' }}>
                  Upload Thumbnail<span className="asterisk">*</span>
                </h6>
                <div
                  style={{ textAlign: 'center', marginTop: '-1rem' }}
                  className="d-flex flex-column align-items-center"
                >
                  <ImageUploader data={thumbnailData} />
                  <div className="message-text error-message">
                    <p>{errorData.thumbnail}</p>
                  </div>
                  <div
                    className="message-text mt-1 italic"
                    style={{ color: '#707070', padding: '0 1.75vw' }}
                  >
                    <p>The image file should be 640x360 mm. Format should be .jpeg or .png.</p>
                  </div>
                </div>
              </div>
              <div className="d-flex flex-column align-items-center">
                <h6 style={{ fontWeight: '600' }}>
                  Upload Banner<span className="asterisk">*</span>
                </h6>
                <div
                  style={{ textAlign: 'center', marginTop: '-1rem' }}
                  className="d-flex flex-column align-items-center"
                >
                  <ImageUploader data={bannerData} />
                  <div className="message-text error-message">
                    <p>{errorData.poster}</p>
                  </div>
                  <div
                    className="message-text mt-1 italic"
                    style={{ color: '#707070', padding: '0 1.75vw' }}
                  >
                    <p>The image file should be 1024x576 mm. Format should be .jpeg or .png.</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            className={`mt-3 pr-5 mb-3 d-md-flex ${
              isEdit ? 'justify-content-md-between' : 'justify-content-md-end'
            } `}
          >
            <div style={{ marginLeft: 'auto' }}>
              <CButton
                className=""
                style={{
                  color: '#3a3838',
                  backgroundColor: 'white',
                  marginRight: '2rem',
                  border: '1px solid #bdbdbd',
                  borderRadius: '5px',
                }}
                onClick={() => cancelModal(true)}
              >
                Cancel
              </CButton>
              <CButton
                className="text-white"
                onClick={handleSave}
                style={{
                  color: 'white',
                  backgroundColor: '#20211c',
                  border: '1px solid #bdbdbd',
                  borderRadius: '5px',
                }}
              >
                Save & Next
              </CButton>
            </div>
          </div>
        </div>
      </CCard>
    </>
  )
}

export default ContentDetails
